import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import {
  serializeArrayQueryParam,
  deserializeArrayQueryParam,
} from 'uplisting-frontend/utils/query-params-helpers';

export default class BaseRoute extends Route {
  @service store!: Services['store'];
  @service router!: Services['router'];
  @service session!: Services['session'];

  protected isComingFromSameRoute(transition: Transition): boolean {
    return transition.from?.name === this.fullRouteName;
  }

  serializeQueryParam(
    value: unknown,
    key: string,
    valueType: string,
  ): string | null | undefined {
    return (serializeArrayQueryParam(value, key, valueType) ||
      super.serializeQueryParam(value, key, valueType)) as
      | string
      | null
      | undefined;
  }

  deserializeQueryParam(
    value: unknown,
    key: string,
    valueType: string,
  ): unknown {
    return (
      deserializeArrayQueryParam(value as unknown[], key, valueType) ||
      super.serializeQueryParam(value, key, valueType)
    );
  }
}
